import { render } from "./AuctionManage.vue?vue&type=template&id=87385212&scoped=true"
import script from "./AuctionManage.vue?vue&type=script&lang=js"
export * from "./AuctionManage.vue?vue&type=script&lang=js"

import "./AuctionManage.vue?vue&type=style&index=0&id=87385212&lang=scss&scoped=true"

import exportComponent from "D:\\myWork\\SAAS\\Group-Carwins-H5-1.0\\carwins-h5\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-87385212"]])

export default __exports__